import { translate } from 'i18n/jhipster-language';
import { FIELD_CONSTRAINTS } from 'shared/lib/validation/field-constraints';
import { validateDateRange } from 'shared/lib/validation/search-filters';
const requiredMsg = () => translate('entity.validation.required');
const minNumMsg = () => translate('entity.validation.min', { min: FIELD_CONSTRAINTS.NUMBER_MIN });
const maxLenMsg = (max) => translate('entity.validation.maxlength', { max: max });
const parseIsoDate = (value) => {
    const t = value?.trim();
    if (!t)
        return null;
    const d = new Date(t);
    return Number.isNaN(d.getTime()) ? null : d;
};
export function validateCardProductLimitForm(form) {
    const errors = {};
    if (!form.windowType?.trim()) {
        errors.windowType = requiredMsg();
    }
    if (!form.currencyCode?.trim()) {
        errors.currencyCode = requiredMsg();
    }
    else if (form.currencyCode.trim().length > FIELD_CONSTRAINTS.TEXT_MAX) {
        errors.currencyCode = maxLenMsg(FIELD_CONSTRAINTS.TEXT_MAX);
    }
    if (form.countLimit == null || Number.isNaN(Number(form.countLimit))) {
        errors.countLimit = requiredMsg();
    }
    else if (Number(form.countLimit) < FIELD_CONSTRAINTS.NUMBER_MIN) {
        errors.countLimit = minNumMsg();
    }
    if (!form.appliesToChannel?.trim()) {
        errors.appliesToChannel = requiredMsg();
    }
    if (!form.appliesToCountry?.trim()) {
        errors.appliesToCountry = requiredMsg();
    }
    if (!form.effectiveFrom?.trim()) {
        errors.effectiveFrom = requiredMsg();
    }
    if (!form.effectiveUntil?.trim()) {
        errors.effectiveUntil = requiredMsg();
    }
    const rangeError = validateDateRange(parseIsoDate(form.effectiveFrom), parseIsoDate(form.effectiveUntil));
    if (rangeError) {
        errors.effectiveUntil = rangeError;
    }
    return errors;
}
export function isCardProductLimitFormValid(form) {
    return Object.keys(validateCardProductLimitForm(form)).length === 0;
}
